export default "__VITE_ASSET__c41b7766__"